import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const RightNavDesktop = () => {
  const [tooltip, setTooltip] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const tooltipInteraction = { BOOKING_BUTTON: 1 };

  const scrollHeight = () => {
    setScrollY(window.pageYOffset);
  }

  useEffect(() => {
    const retrievedTooltip = JSON.parse(localStorage.getItem('tooltipInteraction'));
    if (retrievedTooltip !== null && retrievedTooltip.BOOKING_BUTTON === 1) {
      setTooltip(false);
    } else {
      setTooltip(true);
    }

    const watchScroll = () => {
      window.addEventListener('scroll', scrollHeight);
    }

    watchScroll();
    return () => {
      window.removeEventListener('scroll', scrollHeight);
    };
  }, []);

  const handleTrigger = () => {
    setTooltip(false);
    localStorage.setItem('tooltipInteraction', JSON.stringify(tooltipInteraction));
  }

  return (
    <div className="d-none d-lg-inline-block">
      <Link
        to="!#"
        className="btn btn-link font-weight-medium"
      >Log in</Link>
      <div className="Header-BookOnline">
        <Link
          to="/book-online"
          className={`Header-BookOnline__Btn btn btn-${scrollY > 531 ? 'primary' : 'outline-primary'}`}
        >Book Online</Link>
        {
          tooltip &&
            <div className="GuestTooltip">
              <p>Need computer help? Click here to book the services or browse our list of services.</p>
              <div className="w-100 d-block text-right">
                <Button
                  size="sm"
                  variant="light"
                  onClick={handleTrigger}
                >Okay</Button>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

export default RightNavDesktop;